import React, { useState } from 'react';
import { useTheme } from '../../../../theme-context';
import DateRangePopover from './DateRange';
import AsyncSelectCheckbox from '../../../../shared/select-checkbox-async';
import Button from '../../../../shared/button';
import SelectCheckbox from '../../../../shared/select-checkbox';
import Datepicker from '../../../../shared/datepicker';
import moment from 'moment';

const filterOptions = [
    { label: 'Run', value: 'run' },
    { label: 'Date Range', value: 'date_range' },
    { label: 'Specific Date', value: 'specific_date' },
]

interface ITabFilters {
    allRuns?: any;
    from?: string;
    to?: string;
    daysProcessed?: any;
    specificDate?: any;
    selectedLatestRun: any;
    selectedDateRange: any;
    hasNextPageRuns?: boolean;
    handleSearchRuns: (search: any) => void;
    onChangeFilters: (value: any, type: string) => void;
    onChangeDateRange: (range: any) => void;
    onClickUpdate: () => void;
    onLoadMore: () => void;
    onClickRefresh: () => void;
}

const TabFilters = ({
    allRuns,
    from,
    to,
    daysProcessed,
    specificDate,
    selectedLatestRun,
    selectedDateRange,
    hasNextPageRuns,
    handleSearchRuns,
    onChangeFilters,
    onChangeDateRange,
    onClickUpdate,
    onClickRefresh,
    onLoadMore
}: ITabFilters) => {
    const { theme } = useTheme();
    const [selectedFilter, setSelectedFilter] = useState<any>(filterOptions?.[0])
    const [enableUpdate, setEnableUpdate] = useState<boolean>(false)

    const onChangeFilter = (value: any) => {
        setSelectedFilter(value)
        setEnableUpdate(true)
    }

    const onRefresh = () => {
        setEnableUpdate(false)
        setSelectedFilter(filterOptions?.[0])
        onClickRefresh()
    }

    const onClickUpdateView = () => {
        setEnableUpdate(false)
        onClickUpdate()
    }

    const onChangeFiltersBefore = (value: any, type: string) => {
        setEnableUpdate(true)
        onChangeFilters(value, type)
    }

    const onChangeDateBefore = (value: any) => {
        setEnableUpdate(true)
        onChangeDateRange(value)
    }

    return (
        <div className='my-2 border border-2 rounded-xl py-2 px-3 border-gray-300 dark:border-gray-100'>
            <div className='flex flex-row items-center justify-between mb-3'>
                <div className='flex flex-row items-center'>
                    <img src={theme === 'dark' ? '/assets/insights-tab/filter-icon-white.svg' : '/assets/insights-tab/filter-icon.svg'} className='object-contain w-[22px] mr-3' />
                    <p className='text-lg dark:text-primary-dark'><span>{daysProcessed} Days Processed - {moment(from).format('MMM DD, YYYY')} to {moment(to).format('MMM DD, YYYY')}</span></p>
                </div>
                <div>
                    <Button
                        label={'Refresh'}
                        icon={<img src={'/assets/insights-tab/refresh.svg'} className='object-contain w-[24px] mr-2' />}
                        className={`flex flex-row justify-center !rounded bg-gray-100 px-2 py-1`}
                        onClickButton={() => onRefresh()}
                    />
                </div>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 mb-6'>
                <div className='cols-span-1 lg:col-span-1 flex flex-col lg:flex-row items-start'>
                    <SelectCheckbox
                        name='Filter data by'
                        options={filterOptions}
                        containerStyle='!mb-0 min-w-[250px] mr-4'
                        selectedOption={selectedFilter}
                        onChangeSelectedOption={onChangeFilter}
                    />
                    {selectedFilter?.value === 'run' &&
                        <AsyncSelectCheckbox
                            name='Select a specific Run Date'
                            placeholder=''
                            onSearch={handleSearchRuns}
                            selectedOption={selectedLatestRun}
                            onLoadMore={onLoadMore}
                            onChange={(e) => onChangeFiltersBefore?.(e, 'latestRun')}
                            options={allRuns || []}
                            hasNextPage={hasNextPageRuns || false}
                        // containerStyle='mb-1 min-w-[100%] lg:min-w-[43%]'
                        />
                    }
                    {selectedFilter?.value === 'date_range' &&
                        <DateRangePopover
                            label='Date Range'
                            containerStyle={'!w-auto'}
                            labelStyle='text-gray-500 dark:!text-gray-300'
                            value={selectedDateRange}
                            onChange={onChangeDateBefore}
                        />
                    }
                    {selectedFilter?.value === 'specific_date' &&
                        <div className='w-[25%]'>
                            <Datepicker
                                label='Choose Date'
                                placeholder=''
                                containerStyle='mb-0'
                                inputValue={specificDate}
                                onChangeInput={onChangeFiltersBefore}
                                inputUniqueName={'specificDate'}
                            />
                        </div>
                    }
                    <div className='h-full flex flex-col justify-center'>
                        <Button
                            label={'Update View'}
                            className={`${enableUpdate ? '' : '!opacity-50'} btn-primary-rounded-less dark:!bg-black ml-4 mt-3 min-w-[150px]`}
                            onClickButton={() => enableUpdate && onClickUpdateView()}
                        />
                    </div>
                </div>
                {/* <div className='flex items-center md:mt-6'>
                    <Button
                        label={'Latest Run'}
                        className='btn-primary-rounded-less w-full dark:!bg-black'
                        onClickButton={() => onRunAll()}
                    />
                </div> */}
            </div>
        </div>
    )
}

export default TabFilters;